import styled from "styled-components";
import { StyledMapContent } from "./interface";

export const MapContent = styled.div<StyledMapContent>`
    display: block;

    .card-options{
        display: none;
    }

    .mapa-header-details{
        display: ${(props) => props.openDetails ? "block !important" : "none !important"};

        p{
            margin-bottom: 10px;
            font-size: 0.8rem;
            text-align: justify;
        }
    }

    .mapa-header{
        display:flex;
        justify-content: space-between;
        margin-bottom: 15px;
        
        p.description{
            text-align: justify;
            font-size: 0.8rem;
        }
        

        h3{
            color: var(--purple-lighter);
            margin-left: 0;
        }

        .mapa-header-info{
            justify-content: ${(props) => props.openDetails ? "space-between" : "flex-end"};
        }

        .mapa-header-percentage{
            color: #fff;
            flex: 0 0 120px;
        }
    }

    .mapa-realizado{
        background-color: red;
        align-items: center;
        color: #fff;
        display: flex;
        flex: 0 1 auto;
        flex-direction: column;
        justify-content: center;
        padding: 10px;
    }

    .gauge-map{
        background: var(--card-background);
        padding: 5px;
        box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
        border-radius: 5px;

        h3{
            color: ${(props) => props.color ? props.color: "unset"};
        }
    }
`;

export default MapContent;
